import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;
  
    .buttons-container {
      display: flex;
      justify-content: center;
      gap: 16px;
      font-family: ManropeBold, sans-serif;
      font-size: 13px;

      button {
        width: 135px;
        padding: 16px 35px;
        justify-content: center;
      }

      .add-button {
        background-color: ${(props) => props.theme.colors.main_cta};
        color: ${(props) => props.theme.colors.widget_background};
        float: right;

        &:hover {
          background-color: ${(props) => props.theme.colors.widget_hover_background};
          color: ${(props) => props.theme.colors.main_cta};
        }

        &:disabled {
          cursor: default;
          background-color: ${(props) => props.theme.colors.inactive};
          color: ${(props) => props.theme.colors.black};
        }
      }
    }
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;

  p {
    margin: auto 0;
  }

  .no-content {
    width: 100%;
    height: 200px;
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    color: ${(props) => props.theme.colors.inactive};
    text-align: center;
    font-style: italic;
    padding-top: 70px;
  }

  .disclaimer {
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    color: ${(props) => props.theme.colors.orange};
    margin: 10px 0;
  }

  .group-entity {
    max-width: 1000px;
    margin: 10px 0;
    width: 100%;
    height: 200px;
    overflow-y: auto;

    .item {
      width: 100%;
      margin-bottom: 5px;
      padding: 7px 15px;
      border-radius: 12px;
      background-color: ${(props) => props.theme.colors.widget_background};
      cursor: pointer;

      .row1 {
        font-family: ManropeSemiBold, sans-serif;
        font-size: 15px;
        line-height: 20px;
        color: ${(props) => props.theme.colors.text}
      }

      .row2 {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
        color: ${(props) => props.theme.colors.inactive}
      }

      &:hover {
        background-color: ${(props) => props.theme.colors.widget_hover_background};
        .row1 {
          color:${(props) => props.theme.colors.main_cta};
          transition: all .2s ease-in;
        }
        transition: all .5s ease-in;
      }
    }

    &::-webkit-scrollbar {
      width: 15px;
    }

    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.background_dashboard};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.background_dashboard};
    }

    .noclick {
      cursor: default;
    }
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, RowContainer, ErrorMessage };
